// import node module libraries
import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

// import layouts
import FooterHaeppyappWithLinks from './footers/FooterHaeppyappWithLinks';
import NavbarHelpCenter from './navbars/help-center/NavbarHelpCenter';

const HelpCenterLayout = (props) => {
	return (
		<Fragment>
			<NavbarHelpCenter className="navbar-default" />
			<main className="bg-white">
				{props.children}
				<Outlet />
			</main>
			<FooterHaeppyappWithLinks />
		</Fragment>
	);
};

export default HelpCenterLayout;
